import { useTranslation } from 'react-i18next'
import {
    Box,
    Button,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
} from '@chakra-ui/react'

const DialogUnEnroll = ({ unEnrollSubject, closeUnEnrollSubject, student, handleSubmitUnEnroll }) => {

    const { t } = useTranslation()

    return (

        <AlertDialog isOpen={unEnrollSubject} onClose={closeUnEnrollSubject} >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <form onSubmit={handleSubmitUnEnroll}>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('managesubjectPage.deleteSubject')}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            {`คุณต้องการลบ  ${student?.student?.firstname} ${student?.student?.lastname}`}
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Box justify='space-between'>
                                <Button onClick={closeUnEnrollSubject} color={'gray.500'} _hover={{
                                    transform: 'translateY(-2px)',
                                    boxShadow: 'lg',
                                }}>
                                    {t('Button.close')}
                                </Button>
                                <Button bg={'tomato'} color={'white'} _hover={{
                                    transform: 'translateY(-2px)',
                                    boxShadow: 'lg',
                                }} type='submit' ml={3}>
                                    {t('Button.delete')}
                                </Button>
                            </Box>
                        </AlertDialogFooter>
                    </form>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}
export default DialogUnEnroll